import axios from "axios";
import { API_URL } from "../utils/config";
import { ASSESMENT_STATUS } from "@asez/shared";

export const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const getAssessmentIdAPIresponse = async () => {
  try {
    const response = await axiosInstance.post(
      "/assessment/create-default-assessment"
    );
    return response.data.id;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateAssessmentStatus = async (params: {
  id: string;
  status: ASSESMENT_STATUS;
}) => {
  try {
    const response = await axiosInstance.post(
      "/assessment/update-assessment-status",
      params
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
